import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Parent's Guide" }) => {
    return (
        <AnimationRevealPage>
            <Header />
            <Container>
                <ContentWithPaddingXl>
                    <HeadingRow>
                        <Heading>{headingText}</Heading>
                    </HeadingRow>
                    <Text>

                        <p>
                            In an effort to offer parents the best available information on safety in games, we have partnered with Internet Matters. Go visit our partner page for a vast selection of informative resources on anything related to online safety.
                        </p>

                        <p>
                            Since you’re here, most likely you, or someone you care about, have picked up one of our games in the name of fun. Thank you! We hope you enjoy them as much as we do making them.
                        </p>
                        <p>
                            So; you probably have questions about keeping you, or your children safe while connected to our games through your mobile device. Things like age limits, in-app purchases, and privacy are all very valid concerns, and we’re here to make sure that you get the support you need.
                        </p>
                        <p>
                            To make sure you can enjoy Red Falcon games in a safe and controlled environment, we stick to a clear set of principles that’ve served our gamers and us well:
                        </p>
                        <p>
                            1.We respect our gamers, and we put all our might into making the most fun games for them to enjoy. We’ll never sacrifice game quality for any other short-term considerations.
                        </p>
                        <p>
                            2.We want you to be in total control of your experience with Red Falcon games. That means that before you or your child download our games, you should be given upfront information about the game’s content. This means that it should be totally clear when you’re about to make any purchases within a game.
                        </p>
                        <p>
                            3.If you or your child ever has any problems with our games, you should be able to quickly find out how to fix it. As well as providing guides like this, that means helping you to contact the right company for your issue, whether it’s to do with payments (which will usually be Google or Apple, who process purchases and refunds) or the game itself (which will usually be us).
                        </p>
                        <p>
                            Read on as we try to cover what might be your most likely questions. If we’ve missed anything, email us at support@falcon-games.com. In your email, be sure to include any specific details that might be useful, like what happened and when, possible transaction ID receipts, relevant screenshots, etc.
                        </p>
                        <h1>
                            WHERE ARE RED FALCON GAMES AVAILABLE?
                        </h1>

                        <p>
                            Our games are globally available for free on iOS or Android phones and tablets. To start playing one of our games, the game's app has to be downloaded to the device via the Play Store (Android) or App Store (Apple). So far, we've launched two games globally: Football GOAT, Baseball GOAT.
                        </p>
                        <h1>
                            WHAT ARE THE AGE LIMITS FOR RED FALCON GAMES?
                        </h1>
                        <p>
                            Our games do not have general age limits. However, users of our games should observe that, under our Terms of Service, users under the legal age of majority in the country of their residence require their legal guardian’s approval of our Terms of Service before registering their account.
                        </p>
                        <p>
                            Please note: When you download our games from e.g. Google Play or Apple's App Store you will find published age recommendations in the apps description. However, these age or maturity classifications refer only to the content suitability (similar to movie ratings G, PG or PG-13 in the U.S., but related to gameplay, animations, etc.) according to the respective rating body responsible for such ratings. As these ratings are done independently by a third party without our contribution, they are not necessarily in line with our Terms of Service.
                        </p>
                        <p>
                            For more info on how these categories are defined, visit these support websites for Apple and Google.
                        </p>
                        <h1>
                            PRIVACY AND PROCESSING OF PERSONAL DATA
                        </h1>
                        <h2>
                            USERNAME
                        </h2>

                        <p>
                            Our players are asked to set up a username during the game's tutorial. We recommend that our players choose a nickname not directly identifiable to the players real-life person to increase security and privacy. You are able to change the username through the in-game settings (open the game, tap on the gear-wheel icon and look for "change name").
                        </p>
                        <h2>
                            PAYMENT INFORMATION
                        </h2>
                        <p>
                            We do not store any credit card information related to in-game purchases as the payment transactions are completed through Apple's App Store or Google Play (depending on your device) via the personal email address associated with that account.
                        </p>
                        <h2>
                            MARKETING
                        </h2>
                        <p>
                            When contacting our support through the in-game chat, you'll have the option to share your email address with us. We'll always ask for your consent when sending direct marketing messages to your mobile device. We won't sell or disclose your personal data to third parties for their own commercial purposes.
                        </p>
                        <p>
                            Please find out more about our privacy and data processing practices from our Privacy Policy.
                        </p>
                        <h1>
                            ARE RED FALCON GAMES FREE TO PLAY?
                        </h1>

                        <p>
                            All Red Falcon games are free to download, offering optional "in-app purchases". In-app purchases are never required to play the game, but can be used to enhance certain gameplay elements. In-app purchases vary in price, ranging from $0.99 to $99.99 (without taxes) in U.S. app stores, for example. In-app purchases are paid for with real money, and are always clearly labeled as such. They are accessible "in game", meaning that the options to make a purchase are found within the game itself.
                        </p>
                        <h1>
                            CAN I MANAGE OR TURN OFF IN-APP PURCHASES?
                        </h1>
                        <p>
                            As long as no payment information (e.g. credit card information) is added to your child's device, no purchases can be made. Should you decide to make purchases for your child and for this reason add your payment information to the device, remember to adjust password protection settings, or disable in-app purchases entirely afterwards to avoid unauthorised purchases.
                        </p>
                        <p>
                            In-app purchase settings are different depending on what sort of device you are using. Find the instructions you need linked below:
                        </p>
                        <p>
                            ▪ Instructions for Apple iOS devices (like iPhone or iPad)
                        </p>
                        <p>
                            ▪ Instructions for Google Android devices (like Samsung Galaxy, OnePlus, HTC, Nexus, etc)
                        </p>
                        <h1>
                            WHO PROCESSES IN-APP PURCHASES?
                        </h1>

                        <p>
                            Red Falcon does not process payments for in-app purchases, or have access to credit card information. Payment transactions themselves are processed through the App Store or Google Play (depending on your device) via the personal email address associated with that account. Transaction receipts are emailed to you by Apple or Google after each purchase. Sometimes, purchases may be bundled together if you've bought multiple items, and it might take a few days for you to receive the receipt. These post-purchase processes are subject to change by Apple or Google. Red Falcon doesn't offer any billing programs.
                        </p>
                        <h1>
                            ARE MY BANK DETAILS KEPT PRIVATE?
                        </h1>
                        <p>
                            We don't process payments for in-app purchases, nor do we have access to any of your payment information. That's because the payment transactions themselves are completed through Apple's App Store or Google Play (depending on your device) via your personal email address associated with that account. Receipts for these transactions are emailed to you by Apple or Google after each purchase (though please note that any post-purchase processes are controlled by Apple or Google and are subject to change by them).
                        </p>
                        <h1>
                            I'VE MADE AN IN-GAME PURCHASE, BUT I HAVEN'T RECEIVED WHAT I PAID FOR. WHAT NOW?
                        </h1>
                        <p>
                            Usually transactions are instant. However in rare cases it can take up to 48 hours for transactions to process through Apple or Google and then make it into your game. It is also recommended to restart the app by fully closing and re-opening it. Sometimes a fresh connection to the servers can trigger the in-app currency to appear.
                        </p>
                        <p>
                            If it's been 48 hours and still nothing has happened, please contact Apple or Google directly for more information.
                        </p>
                        <h1>
                            MY CHILD ACCIDENTALLY MADE AN IN-APP PURCHASE. CAN I GET A REFUND?
                        </h1>

                        <p>
                            As with most downloadable software products, items bought in our games (in-app purchases) are non-refundable. In rare cases, exceptions can be applied.
                        </p>
                        <p>
                            If the purchase was made on an Apple (iOS) device:
                            For purchases made on an iOS device, Red Falcon is not able to handle refunds directly. Please visit Apple support and select the "Contact iTunes store support" link, then "Purchases, billing and redemption" and choose the option that fits you best.
                        </p>
                        <p>
                            If the purchase was made on a Google (Android) device:
                            Please send an email to Support@falcon-games.com or contact us In your message please state the name of the game the purchase was made in and add the receipt of the purchase. The transaction ID (looks similar to this - GPA.1234-1234-1234-12345) at the bottom of the document must be visible. Receipts for transactions have been emailed to you by Google after each purchase.
                        </p>
                        <p>
                            Please note: Receipts for any transactions are emailed to you by Apple or Google soon after each purchase. However, purchases may be bundled together if you've bought multiple items and might take longer. These post-purchase processes are subject to change by Apple or Google. Red Falcon doesn't offer any billing programs.
                        </p>
                        <h1>
                            WHERE DO I FIND MY PURCHASE HISTORY?
                        </h1>
                        <p>
                            To review your purchase history, please check the guides below:
                        </p>
                        <h2>
                            Android
                        </h2>

                        <p>
                            ▪ Enter payments.google.com, then log in with your desired Google account
                        </p>
                        <p>
                            ▪ Select "Transactions" to display your Play Store order history.
                        </p>
                        <p>
                            ▪ Choose an individual entry to view its corresponding receipt.
                        </p>
                        <h2>
                            iOS
                        </h2>
                        <p>
                            ▪ Open iTunes on your computer.
                        </p>
                        <p>
                            ▪ Select your username (this should be your e-mail address), and choose "Account"
                        </p>
                        <p>
                            ▪ Scroll down to "Purchase History", and choose "See All"
                        </p>
                        <h1>
                            HOW CAN I CONTACT RED FALCON?
                        </h1>
                        <p>
                            Like we said, we’re here to help! If you have any more questions, there are several ways you can contact us!
                        </p>
                        <h2>
                            CAN I CALL RED FALCON?
                        </h2>
                        <p>
                            We don't offer support via phone but we are easy to reach either directly from within the game or via email. Our well trained support staff is happy to answer your questions 24/7 in the following languages: Arabic, Chinese (Simplified & Traditional), English, Finnish, French, German, Indonesian, Italian, Japanese, Korean, Malay, Portuguese, Russian, Spanish and Turkish.
                        </p>

                        <h2>
                            CONTACT VIA EMAIL
                        </h2>
                        <p>
                            You can send us an email at Support@falcon-games.com. In your email, be sure to include any specific details that might be useful, like what happened and when, possible transaction ID receipts, relevant screenshots, etc.
                        </p>
                        <h1>
                            SAFETY CHECKLIST
                        </h1>
                        <p>
                            Red Falcon's games are made to be enjoyed. They can be a great way to destress and take a break. If you feel as though your child isn't having much fun with the games, then don't be afraid to speak to them about it. Below is a list of things that are worth discussing with your child.
                        </p>
                        <p>
                            1.HAVE A CONVERSATION WITH YOUR CHILD ABOUT GAMING
                        </p>
                        <p>
                            2.Talk about your child's gaming habits. Encourage them to speak to you about anything that upsets them.
                        </p>
                        <p>
                            3.FAMILIARIZE YOURSELF WITH THE GAME AND ITS REPORTING OPTIONS
                        </p>
                        <p>
                            4.We recommend showing interest and even playing the game with your child at regular intervals. Helpful hint: go through in-game tutorials and game guides together in order to make sure you both understand how the game works. In particular, you and your child should know how to use the mute and report tool.
                        </p>
                        <p>
                            5.CHECK YOUR CHILD'S USERNAME
                        </p>
                        <p>
                            6.Make sure your child's in-game nickname is not their real name. You might also want to check if their nickname is inappropriate.
                        </p>
                        <p>
                            7.CHECK IN-APP PURCHASE SETTINGS
                        </p>

                        <p>
                            8.Get familiar with ways to restrict or turn off in-app purchases on your child's device.
                        </p>
                        <p>
                            9.TALK WITH YOUR CHILD ABOUT THE RISKS OF SHARING INFORMATION ONLINE
                        </p>
                        <p>
                            10.Carefully discuss the dangers of talking to strangers online. They should develop a healthy skepticism of who they're talking to and about what. Key things they should NOT share include: gender, age, location, ethnicity, religion, sexuality, height, hobbies
                        </p>
                        <p>
                            11.REPORT / GET HELP
                        </p>
                        <p>
                            12.If all things fail and your child runs into in-game problems, report it so we can help.
                        </p>
                        <h1>
                            ONLINE SLANG GUIDE
                        </h1>
                        <p>
                            A unique new language has emerged online, especially in games. Below are some commonly used terms, in addition to what they mean. This might come in handy when having a conversation with your child about gaming.
                        </p>

                        <table>
                            <thead>
                                <tr>
                                    <th>Word</th>
                                    <th>Meaning</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Noob, n00b</td>
                                    <td>Someone who is new to the game, or acts as though they are new to the game</td>
                                </tr>
                                <tr>
                                    <td>Scrub</td>
                                    <td>An unskilled player</td>
                                </tr>
                                <tr>
                                    <td>Troll</td>
                                    <td>People who taunt, tease or bait other players for a reaction</td>
                                </tr>
                                <tr>
                                    <td>Spamming</td>
                                    <td>When someone repeatedly sends messages or requests</td>
                                </tr>
                                <tr>
                                    <td>BM'ing</td>
                                    <td>Short for "Bad Mannering" - usually involves taunting or poor sportsmanship</td>
                                </tr>
                                <tr>
                                    <td>Doxxing</td>
                                    <td>Broadcasting someone's personal information against their will</td>
                                </tr>
                                <tr>
                                    <td>SWATing</td>
                                    <td>Sending police to someone's home address</td>
                                </tr>
                                <tr>
                                    <td>pwnd / pwn3d</td>
                                    <td>Synonym for "Owned" - term is used when authoritatively outplaying someone else</td>
                                </tr>
                                <tr>
                                    <td>Griefer</td>
                                    <td>Similar to troll, someone who ruins a player's battle or undermines their effort in the game, causing grief</td>
                                </tr>
                                <tr>
                                    <td>Grooming</td>
                                    <td>Befriending and establishing an emotional connection with a child to lower the child's inhibitions with the object of sexual abuse</td>
                                </tr>
                                <tr>
                                    <td>Other</td>
                                    <td>Online Slang Guide</td>
                                </tr>
                            </tbody>
                        </table>


                        <p>
                            Thanks for your help in making our games as safe and as fun as possible!
                        </p>
                        <p>
                            - Your friends at Red Falcon
                        </p>
                    </Text>
                </ContentWithPaddingXl>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
};
